<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />
    <!-- Popup Nav Header -->
    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon>Back
    </div>
    <div class="header text-left">Create Message</div>

    <!-- Image Upload -->
    <v-row class="photo-label">
      <v-col cols="3">
        <label for="cover-photo">Cover Photo</label>
      </v-col>
    </v-row>
    <v-row class="photo-picker">
      <v-col cols="6" md="3">
        <input disabled id="cover-photo" type="text" v-model="imageFileName" />
        <br />
        <input
          style="display: none"
          ref="imageFileInput"
          type="file"
          accept="image/x-png, image/jpeg"
          @change="(e) => setImage(e.target.files[0])"
        />
      </v-col>
      <v-col cols="2">
        <label v-on:click="clickImageInput" id="browse-btn">Browse</label>
      </v-col>
    </v-row>

    <!-- CSV File upload -->
    <v-row>
      <v-col cols="12">
        <label style="margin-bottom: 0">CSV File (List of Receivers)</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          id="csvInput"
          type="file"
          accept=".csv"
          @change="(e) => setCsvData(e.target.files[0])"
        />
        <input type="text" readonly v-model="csvFileName" />
        <div
          class="error-msg"
          v-show="$v.csvFileName.$invalid && $v.title.$dirty"
        >
          Please include a csv file.
        </div>
      </v-col>
      <v-col cols="6" md="3">
        <label for="csvInput" id="browse-btn">Browse</label>
      </v-col>
    </v-row>

    <!-- Start and End Dates -->
    <v-row class="date-labels">
      <v-col cols="6" md="3">
        <label for="startDate">Start Date</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          type="datetime-local"
          id="startDate"
          v-model="startDate"
          @input="$v.startDate.$touch()"
        />
        <div
          class="error-msg"
          v-show="$v.startDate.$invalid && $v.startDate.$dirty"
        >
          Start date has to be at least one day from today.
        </div>
      </v-col>
    </v-row>
    <v-row class="date-pickers">
      <v-col cols="6" md="3">
        <label for="endDate">End Date</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          type="datetime-local"
          id="endDate"
          v-model="endDate"
          @input="$v.endDate.$touch()"
        />
        <div
          class="error-msg"
          v-show="$v.endDate.$invalid && $v.endDate.$dirty"
        >
          End date has to be at least one day from start date.
        </div>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="msg-title">Notification Title</label>
        <input
          id="msg-title"
          type="text"
          v-model="notif_title"
          @input="$v.notif_title.$touch()"
        />
        <div
          class="error-msg"
          v-show="$v.notif_title.$invalid && $v.notif_title.$dirty"
        >
          This is a required field.
        </div>
        <br />
      </v-col>
    </v-row>

    <!-- Content -->
    <v-row>
      <v-col cols="12">
        <label for="msg-content">Notification Content</label>
        <textarea
          id="msg-content"
          v-model="notif_content"
          @input="$v.notif_content.$touch()"
        ></textarea>
        <div
          class="error-msg"
          v-show="$v.notif_content.$invalid && $v.notif_content.$dirty"
        >
          This is a required field.
        </div>
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="msg-title">Inbox Title</label>
        <input
          id="msg-title"
          type="text"
          v-model="title"
          @input="$v.title.$touch()"
        />
        <div class="error-msg" v-show="$v.title.$invalid && $v.title.$dirty">
          This is a required field.
        </div>
        <br />
      </v-col>
    </v-row>

    <!-- Content -->
    <v-row>
      <v-col cols="12">
        <label for="msg-content">Inbox Content</label>
        <!-- <textarea id="msg-content" v-model="content" @input="$v.content.$touch()"></textarea> -->
        <quill-editor
          id="msg-content"
          :content="content"
          class="editor-layout"
          @change="onEditorChange($event)"
        />
        <div
          class="error-msg"
          v-show="$v.content.$invalid && $v.content.$dirty"
        >
          This is a required field.
        </div>
      </v-col>
    </v-row>

    <!-- Button Configurations -->
    <v-row>
      <v-col cols="4" md="3">
        <label for="msg-btn-title">Button Title</label>
        <input
          id="msg-btn-title"
          type="text"
          v-model="btnTitle"
          @input="$v.btnTitle.$touch()"
        />
        <!-- <div class="error-msg" v-show="$v.btnTitle.$invalid && $v.btnTitle.$dirty">This is a required field.</div> -->
      </v-col>
      <v-col v-if="redirectUrl === ''" cols="4" md="3">
        <label for="msg-btn-url">Button Link</label>
        <select v-model="btnLink">
          <option></option>
          <option>Home</option>
          <option>Points</option>
          <option>Profile</option>
          <option>Shop</option>
          <option>Stores</option>
          <option>Instalment Summary</option>
          <option>Ticket Summary</option>
        </select>
      </v-col>
      <v-col v-if="btnLink === ''" cols="4" md="3">
        <label for="msg-btn-url">Button URL</label>
        <input
          id="msg-btn-url"
          type="text"
          v-model="redirectUrl"
          @input="$v.redirectUrl.$touch()"
        />
        <!-- <div class="error-msg" v-show="$v.redirectUrl.$invalid && $v.redirectUrl.$dirty">Please enter a URL in the following format: http://www.example.com/.</div> -->
      </v-col>
    </v-row>

    <!-- Push notification checkbox -->
    <v-row>
      <v-col cols="12">
        <div style="display: flex; align-items: start">
          <label
            for="checkbox-notif"
            style="padding-right: 10px; line-height: 100%"
            >Broadcast Announcement</label
          >
          <input type="checkbox" id="checkbox-notif" v-model="sendNotif" />
        </div>
      </v-col>
    </v-row>

    <!-- Form Submit Button -->
    <v-row>
      <v-col cols="4" md="3">
        <v-btn color="#00457C" :disabled="$v.$invalid" @click="submitMsgForm"
          >Submit</v-btn
        >
      </v-col>
      <v-col cols="4" md="3">
        <v-btn color="#00457C" :disabled="$v.$invalid" @click="preview"
          >Preview</v-btn
        >
      </v-col>
    </v-row>

    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success">Message added successfully.</v-alert>
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>

    <!-- Dialog View -->
    <div
      v-if="currentMessageView !== null"
      class="dialog-msg-wrapper dialog-screen-wrapper"
    >
      <div class="content">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeMsgDialog">Close</span>
        </div>
        <v-img
          alt="msg image"
          class="image-section"
          contain
          :src="currentMessageView.imgUrl"
          transition="scale-transition"
        />
        <div class="title-section">{{ currentMessageView.title }}</div>
        <div class="start-date-section">
          {{ getDisplayDate(currentMessageView.startDate) }}
        </div>
        <div class="desc-section" v-html="currentMessageView.content"></div>
        <div class="action-section" v-if="currentMessageView.btnTitle !== ''">
          <div
            v-on:click="openNewPage(currentMessageView.redirectUrl)"
            class="action-btn"
          >
            {{ currentMessageView.btnTitle }}
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Axios from "axios";
import { required } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";
import moment from "moment";

//form validation: check if end date falls after start date
let checkEndDate = (value, vm) => {
  let startDate = new Date(vm.startDate).getTime();
  let input = new Date(value).getTime();

  if (input > startDate) {
    return true;
  } else {
    return false;
  }
};

//sets btn link as valid if btn url is not selected and vice versa
// let checkLink = (value, vm) => {

//   if (vm.redirectUrl === "") {
//     if (vm.btnLink !== "") {
//       return true
//     }
//     else {
//       return false
//     }
//   }

//   if (vm.btnLink === "") {
//   if (vm.redirectUrl !== "") {
//     return true
//   }
//   else {
//     return false
//   }
// }

//   else {
//     return false
//   }

// }

export default {
  components: {
    LoadingScreen,
  },

  data() {
    return {
      currentMessageView: null,
      notif_title: "",
      notif_content: "",
      title: "",
      content: "",
      startDate: "",
      endDate: "",
      schedule: "",
      btnTitle: "",
      btnLink: "",
      redirectUrl: "",
      imageFile: null,
      imageFileName: "",
      userGuids: null,
      msgContent: null,
      csvFileName: null,
      sendNotif: true,

      loading: false,
      success: false,
      error: false,
    };
  },

  validations: {
    notif_title: {
      required,
    },

    notif_content: {
      required,
    },
    title: {
      required,
    },

    content: {
      required,
    },

    csvFileName: {
      required,
    },

    startDate: {
      required,
    },

    endDate: {
      required,
      checkEndDate,
    },
  },

  methods: {
    closeMsgDialog() {
      this.currentMessageView = null;
    },
    preview() {
      this.currentMessageView = {
        title: this.title,
        content: this.content,
        imgUrl: URL.createObjectURL(this.imageFile),
        startDate: this.startDate,
        btnTitle: this.btnTitle,
        redirectUrl: this.redirectUrl,
        btnLink: this.btnLink,
      };

      // console.log(this.currentAccouncementView.imgUrl);
    },
    getDisplayDate(date) {
      return moment(date).format("DD MMM YYYY");
    },
    goBack() {
      this.$store.dispatch("loadView", "Messages");
    },
    // TODO: validate redirect url to have http://
    // TODO: validate image to be of a certain aspect ratio
    setImage(file) {
      if (file !== null) {
        // Set image file
        this.imageFile = file;
        this.imageFileName = file.name;
      }
    },
    setCsvData(file) {
      if (file !== null) {
        // Parse csv file
        this.$papa.parse(file, {
          header: true,
          complete: ({ data }) => {
            // Set csv file
            this.userGuids = data
              .filter((info) => info.guid !== "")
              .map((info) => info.guid);
            this.msgContent = data
              .filter((info) => info.guid !== "")
              .map((info) => [
                info.guid,
                info.notif_title,
                info.notif_content,
                info.inbox_title,
                info.inbox_content,
                info.button_title,
                info.button_link,
                info.redirect_link,
                info.start_date,
                info.end_date,
              ]);

            // Set csv file name
            this.csvFileName = file.name;
          },
        });
      }
    },
    submitMsgForm() {
      this.loading = true; //enable loading screen once user clicks submit
      const msgFormData = new FormData();
      msgFormData.append("imageFile", this.imageFile);
      // Upload image to AWS
      Axios.post(
        process.env.VUE_APP_HOST_SERVER + "/api/image_upload/messages",
        msgFormData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
        .then((res) => {
          console.log(
            "Successfully uploaded message image ",
            res.data.imageUrl
          );
          const imageUrl = res.data.imageUrl;
          const startDateTime = this.startDate;
          const endDateTime = this.endDate;

          const msgDetails = {
            imgUrl: imageUrl,
            notif_title: this.notif_title,
            notif_content: this.notif_content,
            title: this.title,
            content: this.content,
            startDate: new Date(startDateTime),
            endDate: new Date(endDateTime),
            btnTitle: this.btnTitle,
            redirectUrl: this.redirectUrl,
            btnLink: this.btnLink,
            userGuids: this.userGuids,
            msgContent: Object.assign({}, this.msgContent),
          };
          console.log(msgDetails);
          // Update Mongodb
          Axios.post(
            process.env.VUE_APP_HOST_SERVER + "/api/messages/add",
            msgDetails
          ).then((res) => {
            // Send push notification
            if (this.sendNotif == true) {
              Axios.post(
                process.env.VUE_APP_HOST_SERVER +
                  "/api/notifications/send_notif/guid",
                {
                  notif_title: this.notif_title,
                  notif_content: this.notif_content,
                  title: this.title,
                  bodyMessage: this.bodyMessage,
                  userGuids: this.userGuids,
                  msgContent: this.msgContent,
                  startDate: this.startDate,
                  endDate: this.endDate,
                  objectId: res.data,
                }
              );
            }

            this.loading = false; //disable loading screen once request is handled
            this.success = true; //show success message
            this.error = false;

            console.log("Successfully created message ", msgDetails);
          });
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },
    clickImageInput() {
      this.$refs.imageFileInput.click();
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
  },
};
</script>

<style scoped>
.dialog-msg-wrapper .content {
  width: 400px;
  height: 800px;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.dialog-msg-wrapper .close-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
}

.dialog-msg-wrapper .close-section .close-btn {
  cursor: pointer;
  color: #ea6254;
  font-size: 11px;
  font-weight: bold;
}

.dialog-msg-wrapper .image-section {
  flex-basis: 170px;
}

.dialog-msg-wrapper .title-section {
  padding-top: 15px;
  text-align: start;
  font-size: 15px;
  font-weight: bold;
}

.dialog-msg-wrapper .start-date-section {
  text-align: start;
  font-size: 9px;
  padding-top: 0px;
  color: #9b9b9b;
  font-weight: bold;
}

.dialog-msg-wrapper .desc-section {
  text-align: start;
  padding-top: 10px;
  font-size: 9px;
  color: #9b9b9b;
  flex-grow: 1;
}

.dialog-msg-wrapper .action-section {
  flex-basis: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dialog-msg-wrapper .action-btn {
  width: fit-content;
  font-size: 12px;
  padding: 5px 15px 5px 15px;
  background-color: #204281;
  color: white;
  border-radius: 20px;
  cursor: pointer;
}

.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.content .date-labels,
.content .photo-label {
  padding-bottom: 0;
}

.content .date-labels > div,
.content .photo-label > div {
  padding-bottom: 0;
}

.content .date-pickers > div,
.content .photo-picker > div {
  padding-top: 0;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"],
input[type="number"],
input[type="date"],
textarea,
select {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}

#csvInput {
  display: none;
}
</style>
